import { Icon } from '@ui-kitten/components';
export default Icon;
//# sourceMappingURL=Icon.js.map